import React from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import * as reducers from "./src/reducers";
import { Provider } from "react-redux";
import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import logger from "redux-logger";
import smoothscroll from "smoothscroll-polyfill";
import thunkMiddleware from "redux-thunk";
import * as actions from "./src/actions/Actions.js";
import { persistStore, persistReducer, createMigrate } from "redux-persist";
import ErrorBoundary from "./src/components/ErrorBoundary.js";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import "core-js/features/object";
import Helper from "./src/functions/Helper.js";
import "./src/css/custom_bootstrap.scss";
//import "./src/css/month-picker.css";
import "swiper/swiper.scss";
import "lazysizes";
import "./src/css/lazy.scss";
import "./src/css/pagination.scss";
import "./src/css/navigation.scss";
import "./src/css/additional_swiper.css";

//import "./src/css/swiper.css"
import "./src/css/shoe_filter_react.css";
import "isomorphic-fetch";
import "./src/css/StyleModal.css";
import { hydrateRoot, createRoot } from "react-dom/client";
import routes from "./src/routes/routesRR6.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

import SwiperCore, {
  Lazy,
  Pagination,
  Navigation as SwiperNavigation,
} from "swiper";

import { onLCP, onINP, onFID, onCLS } from "web-vitals";

if (process.env.NODE_ENV === "development") {
  onCLS(console.log);
  onFID(console.log);
  onLCP(console.log);
  onINP(console.log);
}

SwiperCore.use([Lazy, Pagination, SwiperNavigation]);

const defaultTheme = createTheme();

const migrations = {
  0: (state) => {
    return {
      ...state,
    };
  },
  1: (state) => {
    return {
      ...state,
      persistData: { ...state.persistData, likes: [] },
    };
  },
  2: (state) => {
    return {
      ...state,
      persistData: { ...state.persistData, sortStylesBy: 0 },
    };
  },
};

const persistConfig = {
  key: "shoeReviews",
  storage,
  whitelist: ["persistData"],
  version: 1,
  migrate: createMigrate(migrations, { debug: true }),
};

smoothscroll.polyfill();

let middleware =
  process.env.NODE_ENV === "development"
    ? [
        logger,
        thunkMiddleware,
        require("redux-immutable-state-invariant").default(),
      ]
    : [thunkMiddleware];

const reducer = combineReducers(reducers);
const persistedReducer = persistReducer(persistConfig, reducer);
const store = createStore(
  persistedReducer,
  undefined,
  compose(applyMiddleware(...middleware))
);
const persistor = persistStore(store, null, () => {
  store.dispatch({ type: "REHYDRATION_FINISHED" });
});

/*
const currentRoute =
  routes.find((route) => matchPath(route, window.location.pathname)) || {};

store.dispatch(
  actions.initial_data({
    ...window.__INITIAL_DATA__.data,
    overview: window.__INITIAL_DATA__.overview,
  })
);
store.dispatch(actions.menu(window.__INITIAL_DATA__.menu));

if (window.__INITIAL_DATA__.filters) {
  let filters = window.__INITIAL_DATA__.filters;
  store.dispatch({ type: "SETFILTERS", value: filters });
  store.dispatch({ type: "APPLYFILTER" });

  ///SEO SPLIT TEST
  if (filters.filterType === "player") {
    let player = filters.filters[0].list[0].option;
    if (["Paul George", "Kevin Durant"].includes(player)) {
      store.dispatch({ type: "SORT", value: { sortBy: "rating" } });
    }
  }
}
store.dispatch(actions.filterObject(window.__INITIAL_DATA__.filterObject));
store.dispatch(actions.urlMapping(window.__INITIAL_DATA__.url_mapping));



if (Helper.getValueFromQueryString(window.location.search, "shoe_name")) {
  store.dispatch(
    actions.searchtext(
      Helper.getValueFrom3QueryString(window.location.search, "shoe_name")
    )
  );
}

if (window.__ROUTE_DATA__ && currentRoute?.fetchToDo === "shoe") {
  let fetchedDataResponse = window.__ROUTE_DATA__;
  store.dispatch(actions.shoeData(fetchedDataResponse));

  delete window.__ROUTE_DATA__;
}
*/

let { footer, menu, overview, urlMapping } = window.__GLOBAL_DATA__;

store.dispatch(actions.urlMapping(urlMapping));
store.dispatch(actions.menu(menu));
store.dispatch(actions.set_overview(overview));

if (Helper.getValueFromQueryString(window.location.search, "favs")) {
  store.dispatch(actions.switchValue(1));
}

if (Helper.getValueFromQueryString(window.location.search, "shoe_name")) {
  store.dispatch(
    actions.searchtext(
      Helper.getValueFromQueryString(window.location.search, "shoe_name")
    )
  );
}

//cleaning server side rendering of footer since createPortal doesnt allow for hydrating
//document.getElementById("react_footer").innerHTML = "";

const router = createBrowserRouter(
  routes(store, actions, window.__GLOBAL_DATA__)
);

const flatLoadedData = Object.assign(
  {},
  ...Object.values(router.state?.loaderData)
);

store.dispatch(actions.filterObject(flatLoadedData.filterObject));

if (flatLoadedData.paginatedData) {
  store.dispatch(actions.initial_data({ ...flatLoadedData.paginatedData }));
}

if (flatLoadedData.shoeData) {
  store.dispatch(actions.shoeData(flatLoadedData.shoeData));
}

// I need access to all loaded data from react router here

const cache = createCache({ key: "css", prepend: true });

const container = document.getElementById("shoe_filter_container");

const root = createRoot(container);

root.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId="521451542472-8qli2d7dvjqrkp5vjfig204eut558aou.apps.googleusercontent.com">
      <CacheProvider value={cache}>
        <ThemeProvider theme={defaultTheme}>
          <ErrorBoundary>
            <RouterProvider
              future={{ v7_startTransition: true }}
              router={router}
            />
          </ErrorBoundary>
        </ThemeProvider>
      </CacheProvider>
    </GoogleOAuthProvider>
  </Provider>
);
